import { render, staticRenderFns } from "./ChatUser.vue?vue&type=template&id=e4e02eb8&scoped=true&"
import script from "./ChatUser.vue?vue&type=script&lang=js&"
export * from "./ChatUser.vue?vue&type=script&lang=js&"
import style0 from "./ChatUser.vue?vue&type=style&index=0&id=e4e02eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e02eb8",
  null
  
)

export default component.exports